import { render, staticRenderFns } from "./authFace.vue?vue&type=template&id=538377c7&scoped=true"
import script from "./authFace.vue?vue&type=script&lang=js"
export * from "./authFace.vue?vue&type=script&lang=js"
import style0 from "./authFace.vue?vue&type=style&index=0&id=538377c7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538377c7",
  null
  
)

export default component.exports